import dfFormat from 'date-fns/format';
import { formatInTimeZone } from 'date-fns-tz';

import { Component, HTMLAttributes, PropsWithChildren } from 'react';
import clsx from 'clsx';

export type Props = PropsWithChildren<HTMLAttributes<HTMLElement>> & {
  text: string;
};

function TextWithLineBreaks({ text, className }: Props) {
  return (
    <span className={className} style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
      {text}
    </span>
  );
}

export default TextWithLineBreaks;
